// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ko-0";
export var fileCarousel = "_ko-2";
export var removeFileButton = "_ko-1";